import React from 'react';
export function SmartFaqLine() {
  return <div id="st-faq" />;
}
